import MdNotifications from './index'

const NotificationStore = {
  state: [],

  notify(notification) {
    const newNotification = notification.alert
                            ? !this.state.filter(n => n.heading === notification.heading).length
                            : !this.state.filter(n => n.message === notification.message).length

    newNotification && this.state.push(notification)
  },

  removeNotification(index) {
    this.state.splice(index, 1)

    global.pageNotFound = false
  },

  removeById(id) {
    // const notification = this.state.findIndex(notification => notification.id === id)
    // this.state[notification] && this.state.splice(notification, 1)
    // this.state = this.state.filter(notification => notification.id !== id)
    const indexes = []
    this.state.map((n, i) => {
      n.id === id ? indexes.push(i) : null
    })
    indexes.sort((a, b) => a - b)
    indexes.forEach((n, i) => this.state.splice(n - i, 1))
  },

  showById(id, show = true) {
    // const notification = this.state.filter(notification => notification.id === id)[0]
    // notification ? notification.hide = !show : null
    const notification = this.state.findIndex(notification => notification.id === id)
    this.state[notification] ? this.state[notification].hide = !show : null
  },

  errorState() {
    return this.state.filter(n => n.component).length > 0
  },

  showFirst() {
    const first = this.state.filter(n => n.component)[0]
    first ? first.hide = false : null
  },

  getLast() {
    const errors = this.state.filter(n => n.component)
    return errors[errors.length - 1] || {}
  },

  removeAll() {
    this.state.splice(0)
  },

  reset() {
    this.state = []
  }
}

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$notifications', {
      get() {
        return NotificationStore
      }
    })
    Vue.component('MdNotifications', MdNotifications)
  }
}



// WEBPACK FOOTER //
// ./src/core/components/mdNotifications/install.js